const Colors = {
  grayscale: {
    black: '#000000',
    gray0: '#53565A',
    gray1: '#75787B',
    gray2: '#BABABA',
    gray3: '#D9D9D6',
    gray4: '#F8F8F8',
    white: '#FFFFFF',
  },
  yellow: {
    primary: '#FFDE00',
    primaryActive: '#E5C700',
    primaryHover: '#FFEB66',
  },
  blue: {
    primary: '#0D52E3',
    primaryActive: '#0B49CB',
    primaryHover: '#3D74E8',
  },
  red: {
    primary: '#B80C09',
    primaryActive: '#9C0A07',
    primaryHover: '#C2302D',
  },
};

/* @component */
export default Colors;
